module.exports = __webpack_public_path__ + "img/share-dark.1b19ca0d.svg";